import { useContext } from 'react';

import { PopoverContext } from '../components/root/popover-root.context';

export function usePopoverContext() {
  const ctx = useContext(PopoverContext);
  if (!ctx) throw new Error('Popover components must be used within <Popover.Root>');
  return ctx;
}
